import get from 'lodash/get'

export default {
  computed: {
    identityMeta() {
      return this.$store.getters['fiiAuth/identityMeta']
    },
  },
  methods: {
    async persistPPM(entityPaymentUuid) {
      if (!entityPaymentUuid) return
      const autopayEnabled = get(this.identityMeta, ['autopay', 'enabled'])
      await this.$store.dispatch('dashboard/updateOnboarding', {
        autopay: {
          enabled: autopayEnabled ?? true, // Default to true for autopay
          entity_payment_uuid: entityPaymentUuid,
        },
      })
      this.$analytics.sendEvent('ppm_modal_submitted_success', {
        ppm: entityPaymentUuid,
      })
    },
  },
}
